import { HttpHeaders } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { environment } from "src/environments/environment";

export function getHeaderToken(_cookie: CookieService){
    var httpHeaders: HttpHeaders = new HttpHeaders();
    var iocAccessToken = `${environment.appVersion}-${environment.IOC_ACCESS_TOKEN_KEY}`;

    const accessToken = localStorage.getItem(iocAccessToken);

    httpHeaders = httpHeaders.append('ApiKey', environment.apiKey);

    if (accessToken){
        httpHeaders = httpHeaders.append('Authorization', `Bearer ${accessToken}`);
    }

    return httpHeaders;
}